/**
 * 透传参数需要过滤的id
 */
export const queryBlackKeyList = ['debug', 'token', 's', 'id']

export const CLIENT_ID_KEY = 'dchn_client_id'
export const D_UID_ID_KEY = 'dchn_d_uid_id'
export const DCHN_SHARE_LOAD = 0 // 未加载
export const DCHN_SHARE_INIT_ED = 1 // init了
export const DCHN_SHARE_SET_SHARE_ED = 2 // set share 了
